function t(r, e) {
  return function(n) {
    return r(e(n));
  };
}
var o = t;
export {
  o as default
};
//# sourceMappingURL=_overArg.js.map
